import React from "react";

interface Props {
    backgroundColor?: string;
    titleColor?: string;
    textColor?: string;
    children?: React.ReactNode;
    "data-test-id": string;
}

/**
 * TODO: This component can be removed after rebranding is complete, and just pass a background color
 * parameter to the GatsbyImageCard component.
 */
export const JMCCardStyleWrapper = (props: Props): JSX.Element => {
    const { backgroundColor = "white", titleColor = "dark", textColor = "dark", children, ...rest } = props;

    return (
        <span
            data-test-id={rest?.["data-test-id"]}
            style={
                {
                    ...(backgroundColor && { "--card-background-color": `var(--${backgroundColor})` }),
                    ...(titleColor && {
                        "--card-title-color": `var(--${titleColor})`,
                        "--card-full-background-title-color": `var(--${titleColor})`,
                    }),
                    ...(textColor && { "--card-text-color": `var(--${textColor})` }),
                    width: "100%",
                } as React.CSSProperties
            }
        >
            {children}
        </span>
    );
};
